import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { Provider } from '../../../data/models/provider.model';
import phoneUtils, { ProviderPhoneUse } from '../../../services/phoneUtils';
import addressUtils, {
  ProviderAddressUse,
} from '../../../services/addressUtils';
import emailUtils, { ProviderEmailUse } from '../../../services/emailUtils';
import AddressDisplay from '../../AddressDisplay';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface BillingInfoProps {
  provider: Provider | null;
  titleStyle: string;
}

export default function BillingInfo(props: BillingInfoProps) {
  const { t } = useTranslation('common');

  const { provider, titleStyle } = props;

  const address = addressUtils.getProviderAddress(
    provider?.addresses,
    ProviderAddressUse.Billing,
  );

  const email = emailUtils.getProviderEmail(
    provider?.emailAddresses,
    ProviderEmailUse.Billing,
  );

  const phone = phoneUtils.getProviderPhone(
    provider?.phoneNumbers,
    ProviderPhoneUse.Billing,
  );

  return (
    <>
      <Typography className={titleStyle}>{t('provider.billing')}</Typography>
      <Grid container spacing={2} className={FULLSTORY_MASK_CLASSNAME}>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.billingFirst')}
            value={address?.contactFirstName}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.billingLast')}
            value={address?.contactLastName}
          />
        </Grid>
        <AddressDisplay address={address} />
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.billingEmail')}
            value={email?.emailAddress}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.billingPhone')}
            // value={usePhone(phone)}
            value={`${phone?.phoneNumber} ${
              phone?.phoneExtension
                ? `${t('common.extension')}. ${phone.phoneExtension}`
                : ''
            }`}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.bankName')}
            value={provider?.bankName}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.bankRoutingNumber')}
            value={provider?.bankRoutingNumber || ''}
          />
        </Grid>
        <Grid item xs={6}>
          <LabelValue
            label={t('provider.bankAccountNumber')}
            value={provider?.bankAccountNumber || ''}
          />
        </Grid>
      </Grid>
    </>
  );
}
